import { render, staticRenderFns } from "./HaveIncome.vue?vue&type=template&id=4ae56c9c&"
import script from "./HaveIncome.vue?vue&type=script&lang=js&"
export * from "./HaveIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports